/**
 * 获取出发城市
 * @param {*} trip
 */
export function getStartCity(trip) {
  let cityMap = trip.city_info_maps;
  let result = cityMap[trip.start_city];

  return result;
}

/**
 * 获取结束城市
 * @param {*} trip
 */
export function getEndCity(trip) {
  let cityMap = trip.city_info_maps;
  let result = cityMap[trip.end_city];

  return result;
}

/**
 * 获取一个行程的citymap
 * @param {*} trip
 */
export function getCityMap(trip) {
  let result = trip.city_info_maps || {};

  return result;
}

/**
 * 获取一个行程的poi_uid_map
 * @param {*} trip
 */
export function getPoiMap(trip) {
  let result = trip.poi_uid_map || {};

  return result;
}


/**
 * 获取一个trip的出发时间
 * @param {*} trip
 */
export function getStartTime(trip) {
  return trip.start_time;
}

/**
 * 行程poi列表
 * @param {*} trip
 */
export function getPoiList(trip) {
  let result = trip.poi_list ? trip.poi_list.map((item)=>{
    return {...item, pois: [...item.pois], city_list: [...item.city_list]};
  }) : [];
  return result;
}

/**
 * 获取某日详细行程（包含某天行程的城市、poi列表，即是`poi_list[index]`）
 * @param {*} trip
 * @param {*} day 哪天？不能小于1
 */
export function getPoiListItem(trip, day) {
  let poiList = getPoiList(trip);
  let index = day - 1;
  let result = poiList[index];

  return result;
  // return result ? result : {city_list: [], pois: []};
}

export function getDays(trip) {
  return trip.trip_days;
}



// WEBPACK FOOTER //
// ./src/helpers/trip/getStatic.js